var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUnpinned(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "push_pin_FILL0_wght400_GRAD0_opsz24 (1) 1",
    clipPath: "url(#clip0_27_1715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.964 14.134L16.696 16.866L15.696 18.5981L11.3659 16.0981L8.36589 21.2942L6.99986 21.6602L6.63384 20.2942L9.63384 15.0981L5.30371 12.5981L6.30371 10.866L9.03576 10.134L12.5358 4.07177L11.6697 3.57177L12.6697 1.83972L21.33 6.83972L20.33 8.57177L19.464 8.07177L15.964 14.134ZM8.77188 12.291L14.2278 15.441L13.8069 13.8701L17.7319 7.07177L14.2678 5.07177L10.3428 11.8701L8.77188 12.291Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_1715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpinned);
export default __webpack_public_path__ + "static/media/icon_unpinned.3d9108141025e33e99528d9ca0c6330c.svg";
export { ForwardRef as ReactComponent };